import { INITIAL_STATE, setRecentTagCombos, addRecentTagCombo } from '../core'
import {
    RECEIVE_RECENT_TAG_COMBOS,
    ADD_RECENT_TAG_COMBO,
} from '../action_creators'

function recentTagCombos(state=INITIAL_STATE.recentTagCombos, action) {
    switch (action.type) {
        case RECEIVE_RECENT_TAG_COMBOS:
            return setRecentTagCombos(state, action.recentTagCombos)
        case ADD_RECENT_TAG_COMBO:
            return addRecentTagCombo(state, action.recentTagCombo)
        default:
            return state
    }
}

export default recentTagCombos



// WEBPACK FOOTER //
// ./src/redux/reducers/recent_tag_combos_reducer.js